export const JOURNAL_TAGS = ["All stories", "Field notes", "Heritage", "Eco & nature", "Culture", "Mountaineering"] as const;

export type JournalTag = (typeof JOURNAL_TAGS)[number];

export const JOURNAL_FEATURED = {
  slug: "dark-sky-naltar",
  category: "Field notes · Editor's pick",
  title: "A Dark Sky Over Naltar",
  excerpt:
    "Above the tree line, the Milky Way still casts a shadow. A night spent under one of the last truly dark skies in the northern valleys.",
  author: "Imran Yusuf",
  read: "6 min read",
  image: "/images/naltar.jpg",
};

export const JOURNAL_POSTS = [
  {"slug": "travelogue-fading-art-of-sculpture-making-in-taxila", "category": "Heritage", "title": "Fading Art of sculpture making in Taxila", "excerpt": "On a beautiful spring morning, I requested Gandhara Resource Centre a local organization working for preservation & p...", "read": "4 min read", "image": "/images/journal/sculpture-making-taxila.jpeg"},
  {"slug": "air-safari-balochistan-quetta-to-taftan", "category": "Guides", "title": "Air Safari Balochistan - Quetta to Taftan", "excerpt": "It seems our mind is stuck with Gilgit Baltistan when we listen to the word Air Safari! Yes we are blessed. But havin...", "read": "6 min read", "image": "/images/journal/air-safari-balochistan.jpeg"},
  {"slug": "gwadar", "category": "Guides", "title": "Travelogue: Gwadar", "excerpt": "Whenever I mention that I am travelling to Balochistan, the most common response I receive is: “Be safe.” Such is the...", "read": "11 min read", "image": "/images/journal/travelogue-gwadar.jpeg"},
  {"slug": "memory-lane-cecil-murree-green-tourism-pakistan", "category": "Heritage", "title": "Memory Lane - Cecil Murree", "excerpt": "I happened to walk into Cecil Murree for a cup of coffee after many years, and it instantly brought back vivid memori...", "read": "6 min read", "image": "/images/journal/memory-lane-cecil-murree.jpg"},
  {"slug": "bridging-time-my-journey-to-khushal-garh-karak", "category": "Heritage", "title": "Bridging Time: My Journey to Khushal Garh & Karak", "excerpt": "I happened to travel to District Karak lately, which revived many old memories.", "read": "3 min read", "image": "/images/journal/bridging-time-khushal-garh-karak.png"},
  {"slug": "travelogue-naran", "category": "Eco & nature", "title": "Naran", "excerpt": "A bright sunny day in Islamabad, we set off for Naran for the opening of GreenPak Riverfront Resort. Commonly known a...", "read": "7 min read", "image": "/images/journal/travelogue-naran-sep-2025.jpg"},
  {"slug": "travelogue-sadiq-garh-palace-and-fort-derawar", "category": "Heritage", "title": "Travelogue: Sadiq Garh Palace and Fort Derawar", "excerpt": "Started the day with a military function, it’s amazing when veterans are called, they travel far away at their own ex...", "read": "3 min read", "image": "/images/journal/travelogue-sadiq-garh-palace-fort-derawar.jpg"},
  {"slug": "travelogue-uch-sharif-2", "category": "Heritage", "title": "Uch Sharīf", "excerpt": "When I got up early morning, I knew it would be a long day, so pushed out early after Fajr prayers. As I moved out of...", "read": "4 min read", "image": "/images/journal/travelogue-uch-sharif.jpg"},
  {"slug": "travelogue-lipa-valley", "category": "Eco & nature", "title": "Lipa Valley", "excerpt": "Lately PM has emphasised on tourism in AJK and GB. I have fond memories of Kashmir so took to the road to see some do...", "read": "3 min read", "image": "/images/journal/lipa-valley.png"},

  {
    slug: "best-places-pakistan",
    category: "Guides",
    title: "8 of the Best Places to Go in Pakistan",
    excerpt: "From the Karakoram to the Makran coast, where to begin a first trip.",
    read: "9 min read",
    image: "/images/hunza-valley-rakaposhi.webp",
  },
  {
    slug: "lahore-walled-city",
    category: "Heritage",
    title: "Walking Lahore's Walled City",
    excerpt: "Through Delhi Gate at dawn, before the bazaars wake.",
    read: "8 min read",
    image: "/images/badshahi-mosque.jpg",
  },
  {
    slug: "deosai-winter",
    category: "Eco & nature",
    title: "Why Deosai Goes Quiet in Winter",
    excerpt: "The 'land of giants' empties as the brown bears den down.",
    read: "5 min read",
    image: "/images/deosai.jpg",
  },
  {
    slug: "spring-kalasha",
    category: "Culture",
    title: "Spring with the Kalasha",
    excerpt: "The Chilam Joshi festival in the valleys of Chitral.",
    read: "7 min read",
    image: "/images/kalasha-valley.jpg",
  },
  {
    slug: "concordia-walk",
    category: "Mountaineering",
    title: "The Long Walk to Concordia",
    excerpt: "Twelve days to the throne room of the mountain gods.",
    read: "11 min read",
    image: "/images/licensed/baltoro-glacier-from-air.jpg",
  },
  {
    slug: "apricot-season-hunza",
    category: "Field notes",
    title: "Apricot Season in Hunza",
    excerpt: "When the orchards turn and the rooftops fill with fruit.",
    read: "4 min read",
    image: "/images/spring-blossom-hunza.jpg",
  },
  {
    slug: "shandur-polo",
    category: "Culture",
    title: "Polo, the Way It Began",
    excerpt: "Shandur's free-style game at the world's highest ground.",
    read: "6 min read",
    image: "/images/shandur-polo.jpg",
  },
];
